// @ts-nocheck
/*
 * Port of sms-webhook/components/ApiBuilder.js (742 lines). BYTE-IDENTICAL.
 * The interactive URL/Headers/Body builder inside SMS Webhook create/edit â€”
 * paste cURL to auto-populate; toggle Key-Value / Raw modes per section; Test
 * fires the request through PROXY_URL; per-row key/value validation
 * (letters/digits/_/- only, both non-empty); Submit passes the finalized URL
 * and body-string upward via onUseUrl/onResponse for the parent form.
 */
import React, { useEffect, useRef, useState } from 'react';
import {
  Card as ShadCard,
  CardContent as ShadCardContent,
  CardHeader as ShadCardHeader,
} from '@/components/ui/card';
import { Button as _ShadButton } from '@/components/ui/button';
import { Input as ShadInput } from '@/components/ui/input';
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';

const _cx = (...args: any[]) => args.filter(Boolean).join(' ');
const Container: any = ({ fluid, className, children, ...props }: any) => (
  <div className={_cx(fluid ? 'container-fluid' : 'container', className)} {...props}>
    {children}
  </div>
);
const Row: any = ({ className, children, ...props }: any) => (
  <div className={_cx('row', className)} {...props}>
    {children}
  </div>
);
const _colCls = ({ xs, sm, md, lg, xl }: any) => {
  const parts = [];
  if (md) parts.push(`col-md-${md}`);
  if (lg) parts.push(`col-lg-${lg}`);
  if (xl) parts.push(`col-xl-${xl}`);
  if (sm) parts.push(`col-sm-${sm}`);
  if (xs) parts.push(`col-${xs}`);
  if (!parts.length) parts.push('col');
  return parts.join(' ');
};
const Col: any = ({ xs, sm, md, lg, xl, className, children, ...props }: any) => (
  <div className={_cx(_colCls({ xs, sm, md, lg, xl }), className)} {...props}>
    {children}
  </div>
);
const _btnVariantMap: Record<string, any> = {
  primary: 'default',
  secondary: 'outline',
  danger: 'destructive',
  light: 'outline',
  link: 'link',
};
const Button: any = ({ variant, size, className, children, ...props }: any) => {
  let mapped = variant;
  if (typeof variant === 'string') {
    if (variant.startsWith('outline-')) mapped = 'outline';
    else if (_btnVariantMap[variant]) mapped = _btnVariantMap[variant];
    else if (variant.startsWith('btn ')) mapped = 'default';
  }
  return (
    <_ShadButton variant={mapped} size={size} className={className} {...props}>
      {children}
    </_ShadButton>
  );
};
const Card: any = ({ className, children, ...props }: any) => (
  <ShadCard className={className} {...props}>
    {children}
  </ShadCard>
);
Card.Header = ({ className, children, ...props }: any) => (
  <ShadCardHeader className={_cx('font-semibold', className)} {...props}>
    {children}
  </ShadCardHeader>
);
Card.Body = ({ className, children, ...props }: any) => (
  <ShadCardContent className={className} {...props}>
    {children}
  </ShadCardContent>
);
Card.Title = ({ as: As = 'h5', className, children, ...props }: any) => (
  <As className={_cx('text-base font-semibold', className)} {...props}>
    {children}
  </As>
);
Card.Text = ({ className, children, ...props }: any) => (
  <p className={_cx('text-sm text-muted-foreground', className)} {...props}>
    {children}
  </p>
);
Card.Footer = ({ className, children, ...props }: any) => (
  <div className={_cx('border-t border-border px-6 py-3', className)} {...props}>
    {children}
  </div>
);
const Form: any = ({ children, onSubmit, className, ...props }: any) => (
  <form
    className={className}
    onSubmit={onSubmit || ((e: any) => e.preventDefault())}
    {...props}
  >
    {children}
  </form>
);
Form.Group = ({ className, controlId: _c, children, ...props }: any) => (
  <div className={_cx('space-y-2 mb-3', className)} {...props}>
    {children}
  </div>
);
Form.Label = ({ className, children, htmlFor, ...props }: any) => (
  <label
    className={_cx('text-sm font-medium leading-none', className)}
    htmlFor={htmlFor}
    {...props}
  >
    {children}
  </label>
);
Form.Control = ({ as, className, children, isInvalid, ...props }: any) => {
  const invalidCls = isInvalid ? 'border-destructive focus-visible:ring-destructive' : '';
  if (as === 'select')
    return (
      <select
        className={_cx(
          'flex h-9 w-full rounded-md border border-input bg-background px-3 py-1 text-sm shadow-sm focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring',
          invalidCls,
          className,
        )}
        {...props}
      >
        {children}
      </select>
    );
  if (as === 'textarea')
    return (
      <textarea
        className={_cx(
          'flex min-h-[60px] w-full rounded-md border border-input bg-transparent px-3 py-2 text-sm shadow-sm focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring',
          invalidCls,
          className,
        )}
        {...props}
      />
    );
  return <ShadInput className={_cx(invalidCls, className)} {...props} />;
};
Form.Select = ({ className, children, isInvalid, ...props }: any) => (
  <select
    className={_cx(
      'flex h-9 w-full rounded-md border border-input bg-background px-3 py-1 text-sm shadow-sm focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring',
      isInvalid && 'border-destructive focus-visible:ring-destructive',
      className,
    )}
    {...props}
  >
    {children}
  </select>
);
Form.Check = ({
  type = 'checkbox',
  label,
  id,
  className,
  inline,
  children,
  ...props
}: any) => (
  <div className={_cx('flex items-center gap-2', inline && 'inline-flex mr-3', className)}>
    <input
      type={type}
      id={id}
      className="h-4 w-4 rounded border-input text-primary focus:ring-primary"
      {...props}
    />
    {label !== undefined && (
      <label htmlFor={id} className="text-sm leading-none">
        {label}
      </label>
    )}
    {children}
  </div>
);
Form.Text = ({ muted, className, children, ...props }: any) => (
  <small
    className={_cx('text-xs', muted && 'text-muted-foreground', className)}
    {...props}
  >
    {children}
  </small>
);
const Modal: any = ({ show, onHide, size, centered: _c, children, className, ...props }: any) => {
  const sizeCls =
    size === 'sm'
      ? 'sm:max-w-md'
      : size === 'lg'
      ? 'sm:max-w-2xl'
      : size === 'xl'
      ? 'sm:max-w-6xl'
      : '';
  return (
    <Dialog open={!!show} onOpenChange={(o: boolean) => !o && onHide?.()}>
      <DialogContent
        className={`${sizeCls} max-h-[90vh] overflow-y-auto ${className || ''}`.trim()}
        {...props}
      >
        {children}
      </DialogContent>
    </Dialog>
  );
};
Modal.Header = ({ children, closeButton: _cb, className, ...props }: any) => (
  <DialogHeader className={className} {...props}>
    {children}
  </DialogHeader>
);
Modal.Title = ({ children, className, ...props }: any) => (
  <DialogTitle className={className} {...props}>
    {children}
  </DialogTitle>
);
Modal.Body = ({ children, className, ...props }: any) => (
  <div className={`overflow-x-auto ${className || ''}`.trim()} {...props}>
    {children}
  </div>
);
Modal.Footer = ({ children, className, ...props }: any) => (
  <DialogFooter className={className} {...props}>
    {children}
  </DialogFooter>
);
const Table: any = ({
  bordered: _b,
  striped: _s,
  hover: _h,
  responsive: _r,
  className,
  children,
  ...props
}: any) => (
  <table className={_cx('w-full text-sm', className)} {...props}>
    {children}
  </table>
);
const _TabsCtx = React.createContext<any>({});
const Tabs: any = ({
  activeKey,
  defaultActiveKey,
  onSelect,
  children,
  className,
  ...props
}: any) => {
  const [internalKey, setInternalKey] = React.useState(defaultActiveKey || null);
  const current = activeKey !== undefined ? activeKey : internalKey;
  const handle = (k: any) => {
    if (activeKey === undefined) setInternalKey(k);
    onSelect?.(k);
  };
  const tabs = React.Children.toArray(children).filter(Boolean) as any[];
  if (current === null && tabs.length) {
    setInternalKey(tabs[0]?.props?.eventKey);
  }
  return (
    <_TabsCtx.Provider value={{ current, setKey: handle }}>
      <div className={className} {...props}>
        <ul className="nav nav-tabs" role="tablist">
          {tabs.map((t: any) => (
            <li key={t.props.eventKey} className="nav-item" role="presentation">
              <button
                type="button"
                className={_cx('nav-link', current === t.props.eventKey && 'active')}
                onClick={() => handle(t.props.eventKey)}
                disabled={t.props.disabled}
              >
                {t.props.title}
              </button>
            </li>
          ))}
        </ul>
        <div className="tab-content">
          {tabs.map((t: any) => (
            <div
              key={t.props.eventKey}
              className={_cx('tab-pane', current === t.props.eventKey && 'active show')}
              style={{ display: current === t.props.eventKey ? undefined : 'none' }}
            >
              {t.props.children}
            </div>
          ))}
        </div>
      </div>
    </_TabsCtx.Provider>
  );
};
const Tab: any = () => null;
const Tooltip: any = ({ children, id: _id, ...props }: any) => (
  <span {...props}>{children}</span>
);
const OverlayTrigger: any = ({ children, overlay, placement: _p, trigger: _t }: any) => {
  let title = '';
  if (overlay?.props?.children) {
    title =
      typeof overlay.props.children === 'string'
        ? overlay.props.children
        : Array.isArray(overlay.props.children)
          ? overlay.props.children.filter((c: any) => typeof c === 'string').join(' ')
          : '';
  }
  return React.cloneElement(children, { title });
};
const Badge: any = ({ bg, pill, className, children, ...props }: any) => {
  const bgMap: Record<string, string> = {
    primary: 'bg-primary text-primary-foreground',
    secondary: 'bg-secondary text-secondary-foreground',
    success: 'bg-emerald-600 text-white',
    danger: 'bg-destructive text-destructive-foreground',
    warning: 'bg-amber-500 text-white',
    info: 'bg-sky-500 text-white',
    light: 'bg-muted text-muted-foreground',
    dark: 'bg-foreground text-background',
  };
  return (
    <span
      className={_cx(
        'inline-flex items-center px-2 py-0.5 text-xs font-medium',
        pill ? 'rounded-full' : 'rounded-md',
        bg && bgMap[bg],
        className,
      )}
      {...props}
    >
      {children}
    </span>
  );
};
const Spinner: any = ({ animation: _a, size, variant, className, ...props }: any) => (
  <span
    className={_cx(
      'spinner-border',
      size === 'sm' && 'spinner-border-sm',
      variant && `text-${variant}`,
      className,
    )}
    role="status"
    aria-hidden="true"
    {...props}
  />
);
import { PROXY_URL } from '@/utilities/constant';
import { parseCurl, parseNestedStrings, syntaxHighlight } from './apiBuilderUtils';
import { toast } from 'sonner';
import './ApiBuilder.css';

const Notify = {
  notify: (msg) => toast.warning(msg),
};

const ApiBuilder = ({
  initialUrl = '',
  initialMethod = 'GET',
  initialHeaders = [{ key: '', value: '' }],
  initialBody = [{ key: '', value: '' }],
  onUseUrl,
  onMethod,
  onResponse,
  onStateChange,
}: any) => {
  const [url, setUrl] = useState(initialUrl);
  const [headers, setHeaders] = useState<any[]>(initialHeaders);
  const [body, setBody] = useState<any[]>(initialBody);
  const [rawHeaders, setRawHeaders] = useState('');
  const [rawBody, setRawBody] = useState('');
  const [headerMode, setHeaderMode] = useState('key-value');
  const [bodyMode, setBodyMode] = useState('key-value');
  const [response, setResponse] = useState<any>(null);
  const [loading, setLoading] = useState(false);
  const controllerRef = useRef<AbortController | null>(null);
  const showBodyTab = initialMethod === 'POST';
  const [urlError, setUrlError] = useState('');
  const [headerErrors, setHeaderErrors] = useState<any>({});
  const [bodyErrors, setBodyErrors] = useState<any>({});

  useEffect(() => {
    if (onStateChange) {
      onStateChange({
        url,
        method: initialMethod,
        headers,
        body,
        rawBody,
        bodyMode,
        headerMode,
        rawHeaders,
      });
    }
  }, [url, initialMethod, headers, body, rawBody, bodyMode, headerMode, rawHeaders, onStateChange]);

  const handleAddHeader = () => {
    const last = headers[headers.length - 1];
    const key = last.key?.trim();
    const value = last.value?.trim();
    if (!key || !value) return;
    if (!/^[A-Za-z0-9_-]+$/.test(key)) return;
    setHeaders([...headers, { key: '', value: '' }]);
  };

  const handleHeaderChange = (i, field, value) => {
    const updated = [...headers];
    updated[i][field] = value;
    setHeaders(updated);

    const errors = { ...headerErrors };
    const key = updated[i].key?.trim();
    const val = updated[i].value?.trim();

    if (!key && !val) {
      delete errors[i];
    } else if (!key) {
      errors[i] = 'Key cannot be empty';
    } else if (!/^[A-Za-z0-9_-]+$/.test(key)) {
      errors[i] = 'Key can only contain letters, numbers, _ and -';
    } else if (!val) {
      errors[i] = 'Value cannot be empty';
    } else {
      delete errors[i];
    }
    setHeaderErrors(errors);
  };

  const removeHeader = (index) => {
    const updated = headers.filter((_, i) => i !== index);
    setHeaders(updated.length ? updated : [{ key: '', value: '' }]);
  };

  const handleHeaderModeChange = (mode) => {
    if (mode === 'raw') {
      const obj = headers.reduce((acc, { key, value }) => {
        if (key) acc[key] = value;
        return acc;
      }, {} as any);
      setRawHeaders(Object.keys(obj).length ? JSON.stringify(obj, null, 2) : '');
      setHeaderMode('raw');
    } else {
      try {
        const parsed = JSON.parse(rawHeaders || '{}');
        const arr = Object.entries(parsed).map(([key, val]) => ({
          key,
          value: typeof val === 'string' ? val : JSON.stringify(val),
        }));
        setHeaders(arr.length ? arr : [{ key: '', value: '' }]);
        setHeaderMode('key-value');
      } catch {
        Notify.notify('Invalid JSON in raw headers');
      }
    }
  };

  const handleAddBody = () => {
    const last = body[body.length - 1];
    const key = last.key?.trim();
    const value = last.value?.trim();
    if (!key && !value) return;
    if (!key) {
      setBodyErrors((prev) => ({ ...prev, [body.length - 1]: 'Key cannot be empty' }));
      return;
    }
    if (!/^[A-Za-z0-9_-]+$/.test(key)) {
      setBodyErrors((prev) => ({ ...prev, [body.length - 1]: 'Key can only contain letters, numbers, _ and -' }));
      return;
    }
    if (!value) {
      setBodyErrors((prev) => ({ ...prev, [body.length - 1]: 'Value cannot be empty' }));
      return;
    }
    setBodyErrors((prev) => {
      const updated = { ...prev };
      delete updated[body.length - 1];
      return updated;
    });
    setBody([...body, { key: '', value: '' }]);
  };

  const handleBodyChange = (i, field, value) => {
    const updated = [...body];
    updated[i][field] = value;
    setBody(updated);

    const errors = { ...bodyErrors };
    const { key, value: val } = updated[i];

    if (field === 'key') {
      if (isFalsyValue(value)) {
        errors[i] = 'Key cannot be empty';
      } else if (!isValidKey(value)) {
        errors[i] = 'Key cannot contain spaces or special characters';
      } else if (!isFalsyValue(val)) {
        delete errors[i];
      }
    }
    if (field === 'value') {
      if (isFalsyValue(value)) {
        errors[i] = 'Value cannot be empty';
      } else if (isValidKey(key)) {
        delete errors[i];
      }
    }
    setBodyErrors(errors);
  };

  const handleUrlChange = (e) => {
    const value = e.target.value;
    setUrl(value);

    const cleaned = value
      .trim()
      .replace(/^\$+\s*/, '')
      .replace(/^[Cc][Uu][Rr][Ll]\b/, 'curl');

    if (cleaned.toLowerCase().startsWith('curl')) {
      handleClear();
      const parsed = parseCurl(cleaned);
      setUrl(parsed.url ?? '');
      if (parsed.method && onMethod) onMethod(parsed.method);
      setHeaderMode('key-value');
      setBodyMode('key-value');
      setRawHeaders('');
      setRawBody('');

      const headerArray = Object.entries(parsed.headers || {}).map(([key, value]) => ({ key, value }));
      setHeaders(headerArray.length ? headerArray : [{ key: '', value: '' }]);

      if (parsed.body) {
        try {
          const bodyObj = JSON.parse(parsed.body);
          const bodyArray = Object.entries(bodyObj).map(([key, value]) => ({
            key,
            value: value && typeof value === 'object' && !Array.isArray(value) ? JSON.stringify(value) : value,
          }));
          setBody(bodyArray.length ? bodyArray : [{ key: '', value: '' }]);
          setBodyMode('key-value');
          if (String(parsed.method || '').toUpperCase() === 'POST' && onResponse) {
            onResponse(JSON.stringify(bodyObj, null, 2));
          }
        } catch {
          const params = new URLSearchParams(parsed.body);
          const bodyArray: any[] = [];
          const bodyObj: any = {};
          params.forEach((value, key) => {
            bodyArray.push({ key, value });
            bodyObj[key] = value;
          });
          setBody(bodyArray.length ? bodyArray : [{ key: '', value: '' }]);
          setBodyMode('key-value');
          if (String(parsed.method || '').toUpperCase() === 'POST' && onResponse) {
            onResponse(JSON.stringify(bodyObj, null, 2));
          }
        }
      } else {
        setBody([{ key: '', value: '' }]);
      }
    }

    if (!value.trim()) {
      setUrlError('Request URL is required');
    } else if (!isValidUrl(value) && !isValidCurl(value)) {
      setUrlError('Enter a valid URL or valid cURL');
    } else {
      setUrlError('');
    }
  };

  const sendRequest = async () => {
    if (!url) {
      Notify.notify('Please enter a URL');
      return null;
    }
    setLoading(true);
    const abortController = new AbortController();
    controllerRef.current = abortController;

    let headerObj: any = {};

    if (headerMode === 'raw') {
      try {
        headerObj = JSON.parse(rawHeaders || '{}');
      } catch {
        Notify.notify('Raw headers must be valid JSON');
        setLoading(false);
        return;
      }
    } else {
      headerObj = headers.reduce((acc, { key, value }) => {
        if (key) acc[key] = value;
        return acc;
      }, {} as any);
    }

    let requestBody: any = null;
    if (initialMethod === 'POST') {
      const contentTypeKey = Object.keys(headerObj).find((k) => k.toLowerCase() === 'content-type');
      const isJson = contentTypeKey ? headerObj[contentTypeKey].includes('application/json') : false;

      if (bodyMode === 'raw') {
        requestBody = rawBody;
      } else if (isJson) {
        const bodyObj = body.reduce((acc, { key, value }) => {
          if (!key) return acc;
          acc[key] = parseNestedStrings(value);
          return acc;
        }, {} as any);
        requestBody = JSON.stringify(bodyObj);
      } else {
        const formData = new URLSearchParams();
        body.forEach(({ key, value }) => {
          if (key) formData.append(key, value);
        });
        requestBody = formData.toString();
        if (!contentTypeKey) headerObj['Content-Type'] = 'application/x-www-form-urlencoded';
      }
    }

    try {
      const res = await fetch(PROXY_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          url,
          method: initialMethod,
          headers: JSON.stringify(headerObj),
          body: requestBody,
        }),
        signal: abortController.signal,
      });

      const contentType = res.headers.get('content-type');
      const data: any =
        contentType && contentType.includes('application/json') ? await res.json() : await res.text();

      const responseObj = {
        status: data.status,
        statusText: data.statusText,
        headers: data.headers,
        data: data.data,
      };

      setResponse(responseObj);
      return responseObj;
    } catch (err: any) {
      if (err.name === 'AbortError') Notify.notify('Request aborted!');
      else Notify.notify(err.message);
      return null;
    } finally {
      setLoading(false);
      controllerRef.current = null;
    }
  };

  const stopRequest = () => {
    if (controllerRef.current) {
      controllerRef.current.abort();
      controllerRef.current = null;
    }
  };

  const removeBody = (index) => {
    const updated = body.filter((_, i) => i !== index);
    setBody(updated.length ? updated : [{ key: '', value: '' }]);
  };

  const handleClear = () => {
    setUrl('');
    setHeaders([{ key: '', value: '' }]);
    setBody([{ key: '', value: '' }]);
    setRawHeaders('');
    setRawBody('');
    setHeaderMode('key-value');
    setBodyMode('key-value');
    setResponse(null);
  };

  const handleSubmit = async () => {
    if (!url) return;
    if (onUseUrl) onUseUrl(url);
    if (onResponse && initialMethod === 'POST') {
      const bodyString =
        bodyMode === 'raw'
          ? rawBody
          : JSON.stringify(
              body.reduce((acc, { key, value }) => {
                if (!key) return acc;
                acc[key] = parseNestedStrings(value);
                return acc;
              }, {} as any),
              null,
              2,
            );
      onResponse(bodyString);
    }
  };

  const handleBodyModeChange = (mode) => {
    if (mode === 'raw') {
      const obj = body.reduce((acc, { key, value }) => {
        if (!key) return acc;
        acc[key] = parseNestedStrings(value);
        return acc;
      }, {} as any);
      setRawBody(Object.keys(obj).length ? JSON.stringify(obj, null, 2) : '');
      setBodyMode('raw');
    } else if (mode === 'key-value') {
      try {
        const parsed = JSON.parse(rawBody || '{}');
        const arr = Object.entries(parsed).map(([key, val]) => ({
          key,
          value: typeof val === 'string' ? val : JSON.stringify(val),
        }));
        setBody(arr.length ? arr : [{ key: '', value: '' }]);
        setBodyMode('key-value');
      } catch (err) {
        Notify.notify('Invalid JSON in raw body');
      }
    }
  };

  const isValidUrl = (value) => {
    try {
      new URL(value);
      return true;
    } catch {
      return false;
    }
  };

  const isValidCurl = (value) => {
    const cleaned = value.trim().replace(/^\$+\s*/, '').toLowerCase();
    return cleaned.startsWith('curl ');
  };

  const isValidKey = (key) => {
    const trimmed = key?.trim();
    const keyRegex = /^[A-Za-z0-9_-]+$/;
    return keyRegex.test(trimmed);
  };

  const isFalsyValue = (val) => !val || val.trim() === '';

  return (
    <Container className="mt-4 api-tester">
      <h4 className="mb-4 fw-bold border-bottom pb-2">API Builder</h4>
      <Row className="align-items-center mb-3">
        <Col md={10} className="w-100">
          <Form.Label className="fw-semibold">
            Request URL <span style={{ color: 'red', margin: '0 4px' }}>*</span>
          </Form.Label>
          <Form.Control
            as="textarea"
            rows={3}
            placeholder="Enter URL or paste full cURL here"
            value={url}
            size="lg"
            onChange={handleUrlChange}
            style={{ fontSize: '1rem' }}
          />
          {urlError && (
            <div style={{ color: 'red', fontSize: '0.9rem', marginTop: '4px' }}>{urlError}</div>
          )}
        </Col>
      </Row>

      <Tabs defaultActiveKey="headers" className="mb-3 custom-tabs" fill>
        <Tab eventKey="headers" title="Headers">
          <div className="tab-section">
            <div className="mb-2">
              <Button
                type="button"
                variant={headerMode === 'key-value' ? 'primary' : 'outline-primary'}
                size="sm"
                className="me-2"
                onClick={() => handleHeaderModeChange('key-value')}
              >
                Key-Value
              </Button>
              <Button
                type="button"
                variant={headerMode === 'raw' ? 'primary' : 'outline-primary'}
                size="sm"
                onClick={() => handleHeaderModeChange('raw')}
              >
                Raw
              </Button>
            </div>

            {headerMode === 'key-value' ? (
              <>
                {headers.map((h, i) => (
                  <div key={i}>
                    <Row className="mb-2">
                      <Col md={5}>
                        <Form.Control
                          placeholder="Key"
                          value={h.key}
                          onChange={(e) => handleHeaderChange(i, 'key', e.target.value)}
                        />
                      </Col>
                      <Col md={5}>
                        <Form.Control
                          placeholder="Value"
                          value={h.value}
                          onChange={(e) => handleHeaderChange(i, 'value', e.target.value)}
                        />
                      </Col>
                      <Col md={2} className="text-center">
                        <Button
                          type="button"
                          variant="outline-danger"
                          size="sm"
                          onClick={() => removeHeader(i)}
                        >
                          −
                        </Button>
                      </Col>
                    </Row>
                    {headerErrors[i] && (
                      <div style={{ color: 'red', fontSize: '0.85rem' }}>{headerErrors[i]}</div>
                    )}
                  </div>
                ))}
                <Button type="button" variant="outline-primary" size="sm" onClick={handleAddHeader}>
                  + Add Header
                </Button>
              </>
            ) : (
              <Form.Control
                as="textarea"
                rows={8}
                placeholder="Enter raw JSON headers"
                value={rawHeaders}
                onChange={(e) => setRawHeaders(e.target.value)}
              />
            )}
          </div>
        </Tab>

        {showBodyTab && (
          <Tab eventKey="body" title="Body">
            <div className="tab-section">
              <div className="mb-2">
                <Button
                  type="button"
                  variant={bodyMode === 'key-value' ? 'primary' : 'outline-primary'}
                  size="sm"
                  onClick={() => handleBodyModeChange('key-value')}
                  className="me-2"
                >
                  Key-Value
                </Button>
                <Button
                  type="button"
                  variant={bodyMode === 'raw' ? 'primary' : 'outline-primary'}
                  size="sm"
                  onClick={() => handleBodyModeChange('raw')}
                >
                  Raw
                </Button>
              </div>

              {bodyMode === 'key-value' ? (
                <div>
                  {body.map((b, i) => (
                    <div key={i}>
                      <Row className="mb-2">
                        <Col md={5}>
                          <Form.Control
                            placeholder="Key"
                            value={b.key}
                            onChange={(e) => handleBodyChange(i, 'key', e.target.value)}
                          />
                        </Col>
                        <Col md={5}>
                          <Form.Control
                            placeholder="Value"
                            value={b.value}
                            onChange={(e) => handleBodyChange(i, 'value', e.target.value)}
                          />
                        </Col>
                        <Col md={2} className="text-center">
                          <Button
                            type="button"
                            variant="outline-danger"
                            size="sm"
                            onClick={() => removeBody(i)}
                          >
                            −
                          </Button>
                        </Col>
                      </Row>
                      {bodyErrors[i] && (
                        <div style={{ color: 'red', fontSize: '0.85rem' }}>{bodyErrors[i]}</div>
                      )}
                    </div>
                  ))}
                  <Button type="button" variant="outline-primary" size="sm" onClick={handleAddBody}>
                    + Add Body Parameter
                  </Button>
                </div>
              ) : (
                <Form.Group>
                  <Form.Control
                    as="textarea"
                    rows={8}
                    placeholder="Enter raw JSON body here"
                    value={rawBody}
                    onChange={(e) => setRawBody(e.target.value)}
                  />
                </Form.Group>
              )}
            </div>
          </Tab>
        )}
      </Tabs>

      <div className="mt-3">
        {loading ? (
          <Button type="button" variant="danger" onClick={stopRequest}>
            Stop
          </Button>
        ) : (
          <>
            <Button type="button" onClick={sendRequest} disabled={loading} variant="primary">
              Test
            </Button>
            {url && (
              <Button
                type="button"
                variant="success"
                className="ms-2"
                onClick={handleSubmit}
                disabled={loading}
              >
                Submit
              </Button>
            )}
            <Button type="button" variant="outline-secondary" className="ms-2" onClick={handleClear}>
              Clear
            </Button>
          </>
        )}
      </div>

      {response && (
        <div className="mt-4 response-section">
          <h5 className="fw-bold border-bottom pb-2">Response</h5>
          <p>
            <strong>Status:</strong> {response.status} {response.statusText}
          </p>
          <Tabs defaultActiveKey="data" className="mb-3 custom-tabs">
            <Tab eventKey="data" title="Data">
              <pre
                className="p-3 rounded border json-pre"
                dangerouslySetInnerHTML={{
                  __html: (() => {
                    try {
                      const jsonData =
                        typeof response.data === 'object' ? response.data : JSON.parse(response.data);
                      return syntaxHighlight(jsonData);
                    } catch {
                      return response.data;
                    }
                  })(),
                }}
              />
            </Tab>
            <Tab eventKey="headers" title="Headers">
              <div className="overflow-x-auto">
              <Table striped bordered hover size="sm">
                <tbody>
                  {Object.entries(response.headers || {}).map(([k, v]: any) => (
                    <tr key={k}>
                      <td>{k}</td>
                      <td>{v}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
              </div>
            </Tab>
          </Tabs>
        </div>
      )}
    </Container>
  );
};

export default ApiBuilder;
